import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {IManagerRepository} from "@/repository/manager/ManagerRepository.types";
import { Manager, IManager, ManagerResponseType} from "@/entity/manager/manager.types";
import qs from "qs";
import {getResponse, getResponseQs} from "@/repository/Helpers/repositoryLib";

export class ManagerRepository implements IManagerRepository {
    async fetchAll(data?: FormData): Promise<Manager> {
        const response = await getResponse(`/manager/get`, data)
        return response.data  as Manager
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/manager/delete', data);
        return resp.data;
    }
}